import { render } from "./ItemsPerPage.vue?vue&type=template&id=1a66ecf8&scoped=true&ts=true"
import script from "./ItemsPerPage.vue?vue&type=script&lang=ts"
export * from "./ItemsPerPage.vue?vue&type=script&lang=ts"

import "./ItemsPerPage.vue?vue&type=style&index=0&id=1a66ecf8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a66ecf8"]])

export default __exports__